module.exports = __webpack_public_path__ + "static/img/patentleft-4.1d892fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/patentleft-4.png
// module id = z1qm
// module chunks = 0